import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { isNumber } from "../utils/commonUtility";
import { currencyTypes } from "../utils/localeData";
import Currency from "./Currency";
import intl from "../intl";

var FormattedCurrency = function FormattedCurrency(_ref) {
  var currency = _ref.currency,
      value = _ref.value,
      maximumFractionDigits = _ref.maximumFractionDigits;

  if (!isNumber(value)) {
    return 'Invalid Currency Value';
  }

  if (currency === '') {
    return 'Invalid Currency';
  }

  if (typeof currency !== 'string') {
    return '';
  }

  var formattedString = intl.formatNumber(+value, {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: maximumFractionDigits
  });
  return isEmpty(formattedString) ? Currency({
    code: currency.toUpperCase(),
    value: value
  }) : formattedString;
};

FormattedCurrency.defaultProps = {
  currency: 'USD',
  maximumFractionDigits: 2
};
FormattedCurrency.propTypes = {
  /** value is required */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,

  /** currency type (USD,EUR,...) */
  currency: PropTypes.oneOf(currencyTypes),

  /* Maximum numbers after decimal point */
  maximumFractionDigits: PropTypes.number
};
export default FormattedCurrency;